<div id="dialog-delete">
  <mat-dialog-content>{{data.text}} </mat-dialog-content>
  <mat-dialog-actions>
    <button color="primary" mat-flat-button [mat-dialog-close]="true">Ok</button>
  </mat-dialog-actions>
</div>